import React, { useEffect } from 'react';
import { usePagination } from '../../../../../Common/hooks/usePagination';
import { calculateGradesPerPage, findActualGradePageIndex, findSelectedGradePageIndex, getActualGrade, } from './utils';
var useTableGradesPagination = function (_a) {
    var _b, _c;
    var groupGradeValue = _a.groupGradeValue, grades = _a.grades, students = _a.students, selectedGradeShortName = _a.selectedGradeShortName, filters = _a.filters;
    var _d = usePagination(), pageNum = _d.pageNum, goPrev = _d.goPrev, goNext = _d.goNext, resetPage = _d.resetPage, setPage = _d.setPage;
    var gradesPerPage = React.useMemo(function () {
        if (!grades.length)
            return [];
        return calculateGradesPerPage(grades);
    }, [grades]);
    var renderedGrades = React.useMemo(function () {
        if (gradesPerPage.length === 0)
            return [];
        var pageGrades = gradesPerPage[pageNum - 1];
        if (!pageGrades) {
            resetPage();
            return gradesPerPage[0];
        }
        return pageGrades;
    }, [gradesPerPage, pageNum, resetPage]);
    var prevGrade = React.useMemo(function () {
        var prevIdx = pageNum - 2;
        var prevGrades = gradesPerPage[prevIdx];
        if (!prevGrades)
            return null;
        var target = prevGrades[prevGrades.length - 1];
        if (prevGrades.length > 1 && renderedGrades[0].name === target.name) {
            target = prevGrades[0];
        }
        return target;
    }, [gradesPerPage, renderedGrades, pageNum]);
    var nextGrade = (_c = (_b = gradesPerPage[pageNum]) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : null;
    useEffect(function () {
        var _a;
        if (grades.length && students.length) {
            var actualPageNum = 0;
            if (selectedGradeShortName) {
                actualPageNum =
                    findSelectedGradePageIndex(gradesPerPage, selectedGradeShortName) + 1;
            }
            else {
                var actualGrade = getActualGrade(grades, students, filters);
                var actualGradeValue = (_a = actualGrade === null || actualGrade === void 0 ? void 0 : actualGrade.value) !== null && _a !== void 0 ? _a : groupGradeValue;
                if (typeof actualGradeValue === 'number') {
                    var pageIdx = findActualGradePageIndex(gradesPerPage, actualGradeValue);
                    actualPageNum = pageIdx + 1;
                }
            }
            if (actualPageNum) {
                setPage(actualPageNum);
            }
            else {
                resetPage();
            }
        }
    }, [
        groupGradeValue,
        gradesPerPage,
        setPage,
        resetPage,
        filters,
        selectedGradeShortName,
        grades,
        students,
    ]);
    return {
        renderedGrades: renderedGrades,
        prevGrade: prevGrade,
        nextGrade: nextGrade,
        goPrev: goPrev,
        goNext: goNext,
    };
};
export { useTableGradesPagination };
